export enum SettingsScreenSidebarKey {
  display = 'display',
  scanning = 'scanning',
  featureToggles = 'featureToggles',
  triggers = 'triggers',
  users = 'users',
  stockLocations = 'stockLocations',
  customFields = 'customFields',
  integrations = 'integrations',
  barcodes = 'barcodes',
  security = 'security',
  partner = 'partner',
}
